// Main import target for usage, replacing index.js

// Import UIKit Components
import P4aComponents from './plugins/componentLists/P4a-components';
import SnsComponents from './plugins/componentLists/Sns-components';

// Import UIKit Directives
import tooltipDirective from './plugins/directives/tooltip-directive';


const P4aUikitPlugin = {
  install: function (Vue) {
    // declare global eventBus for p4aToasts
    Vue.prototype.$eventBus = new Vue();

    Vue.use(P4aComponents)
    Vue.use(SnsComponents)

    Vue.use(tooltipDirective)

    // still not working on edge, firefox and ie11, works only on chrome
    Vue.prototype.$p4aToast = {};
    Vue.prototype.$p4aToast.show = function(title, message, type, duration, callBackIssue) {
      Vue.prototype.$eventBus.$emit('p4aToast', {
        title,
        message,
        type,
        duration,
        callBackIssue
      })
    }
  }
};

export default P4aUikitPlugin



// WEBPACK FOOTER //
// ./node_modules/pro4all-ui/P4aUikitPlugin.js